import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

// router实例
// eslint-disable-next-line import/no-mutable-exports
export let router: Router;

export function initRouter(base: string) {
    router = new Router({
        mode: 'history',
        base: `${base}/`,
        routes: [
            // 主页
            {
                path: '/',
                name: 'Main',
                alias: '/home',
                component: resolve => {
                    require(['@/pages/home/index.vue'], resolve);
                }
            },
            // 登录
            {
                path: '/auth',
                name: 'Auth',
                component: resolve => {
                    require(['@/pages/auth.vue'], resolve);
                }
            },
            // 登录
            {
                path: '/login',
                name: 'Login',
                component: resolve => {
                    require(['@/pages/login.vue'], resolve);
                }
            },
            // ukey登录
            {
                path: '/ukey-login',
                name: 'UkeyLogin',
                component: resolve => {
                    require(['@/pages/login/index.vue'], resolve);
                }
            },
            // 主页
            {
                path: '/home',
                name: 'Home',
                component: resolve => {
                    require(['@/pages/home/index.vue'], resolve);
                }
            },
            // 个人中心
            {
                path: '/personal/center',
                name: 'PersonalCenter',
                meta: {
                    hideFrame: true
                },
                component: resolve => {
                    require(['@/pages/home/personal.vue'], resolve);
                }
            },
            // 签署列表
            {
                path: '/signlist',
                name: 'SignList',
                component: resolve => {
                    require(['@/pages/sign/index.vue'], resolve);
                }
            },
            // 签署页面
            {
                path: '/inlinesignfile',
                name: 'inLineSignFile',
                component: resolve => {
                    require(['@/pages/sign/inline-sign.vue'], resolve);
                }
            },
            // 开放平台签署页面
            {
                path: '/signfile',
                name: 'SignFile',
                component: resolve => {
                    require(['@/pages/sign/sign.vue'], resolve);
                }
            },
            // 开放平台多节点签署页面
            {
                path: '/zjwsignfile', // 后端规定的路由名
                name: 'Zjwsignfile',
                component: resolve => {
                    require(['@/pages/sign/multiple-sign.vue'], resolve);
                }
            },
            // 多份文档签署页面
            {
                path: '/czbbatchsignfile',
                name: 'Multiplesignfile',
                meta: {
                    hideFrame: true
                },
                component: resolve => {
                    require(['@/pages/sign/batch-sign.vue'], resolve);
                }
            },
            // 个人签名
            {
                path: '/personal',
                name: 'Personal',
                component: resolve => {
                    require(['@/pages/sign/signatory.vue'], resolve);
                }
            },
            // 手写签名板
            {
                path: '/settingsignature',
                name: 'settingSignature',
                meta: { hideFrame: true, loginAuth: true },
                component: require('../components/signature/index.vue').default
            },
            // 验签
            {
                path: '/verify',
                name: 'Verify',
                component: resolve => {
                    require(['@/pages/verify/index.vue'], resolve);
                }
            },
            // 验签结果
            {
                path: '/verify/result',
                name: 'verifyResult',
                component: resolve => {
                    require(['@/pages/verify/verify-result.vue'], resolve);
                }
            },
            // 验签结果
            {
                path: '/qrcode/detail',
                name: 'qrcodeDetail',
                meta: { hideFrame: true },
                component: resolve => {
                    require(['@/pages/verify/qrcode-detail.vue'], resolve);
                }
            },

            // qrcode详情
            {
                path: '/qrcode/detail/v2',
                name: 'qrcodeDetailV2',
                meta: { hideFrame: true },
                component: resolve => {
                    require(['@/pages/verify/qrcode-detail-v2.vue'], resolve);
                }
            },

            // 印章列表
            {
                path: '/seal',
                name: 'Seal',
                component: resolve => {
                    require(['@/pages/seal/index.vue'], resolve);
                }
            },
            // 印章备案记录
            {
                path: '/sealrecord',
                name: 'SealRcord',
                component: resolve => {
                    require(['@/pages/seal/record.vue'], resolve);
                }
            },
            // 创建印章备案
            {
                path: '/sealrecord/create',
                name: 'CreateSealRcord',
                component: resolve => {
                    require(['@/pages/seal/create-record.vue'], resolve);
                }
            },
            // 市民主页
            {
                path: '/citizens',
                name: 'Citizens',
                meta: { hideFrame: true },
                component: resolve => {
                    require(['@/pages/home/citizens.vue'], resolve);
                }
            },
            // 印章详情
            {
                path: '/seal/:id',
                name: 'SealDetail',
                component: resolve => {
                    require(['@/pages/seal/detail.vue'], resolve);
                }
            },
            // 申请印章
            {
                path: '/sealcreate',
                name: 'SealCreate',
                component: resolve => {
                    require(['@/pages/seal/create.vue'], resolve);
                }
            },
            // 当前印章
            {
                path: '/currentseal',
                name: 'currentSeal',
                component: resolve => {
                    require(['@/pages/seal/current.vue'], resolve);
                }
            },
            // 访问管理
            {
                path: '/access',
                name: 'access',
                component: resolve => {
                    require(['@/pages/access/index.vue'], resolve);
                }
            },
            // 印模管理
            {
                path: '/mould',
                name: 'mould',
                component: resolve => {
                    require(['@/pages/mould/index.vue'], resolve);
                }
            }
        ]
    });
}
